export const TOOLS = {
	SELECT: 'select',
	RESIZER: 'resizer',
	HAND: 'hand',
	STICKER: 'sticker',
	CARD: 'card',
	ZOOM: 'zoom',
	DEV: 'dev',
};
